import { Box, Container } from '@mui/material'
import { useTranslation } from 'react-i18next'
import Header from '../../../../shared/components/Header'
import ButtonBack from '../../../../shared/components/buttons/ButtonBack'
import SubHeader from '../../../../shared/styles/Subheader'
import LessonDetail from '../componentes/LessonDetail'

function LessonsView() {
  const { t } = useTranslation(['global'])

  return (
    <>
      <Header title={t('acedemy')} />
      <SubHeader />

      <Container maxWidth="md">
        <Box display="flex" mt={6}>
          <ButtonBack />
        </Box>

        <LessonDetail lesson={[]} course={[]} />
      </Container>
    </>
  )
}

export default LessonsView
